const LightningIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={props.width ?? 18} height={props.height ?? 24} viewBox="0 0 18 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" fill={props.color}
            d="M13.3991 0.000244141L0.5 13.5203H7.46193L3.75324 24.0002L17.181 9.71635H10.5525L13.3991 0.000244141Z" />
    </svg>
);

export default LightningIcon;